import { render } from "./HeroiconsSolidFastForward.vue?vue&type=template&id=52b18f2f"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFastForward.vue"]])

export default __exports__